import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    vdpRunDetails: []
}

function setVdpRunDetails(state, action){
    return {
        ...state,
        vdpRunDetails: action.vdpRunDetails
    }
}

export default reduce(initialState,{
    [actionTypes.VDP_RUN_DETAILS_SET]: setVdpRunDetails
});


// WEBPACK FOOTER //
// ./src/redux/vdpRuns/vdpRunReducer.js